import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServerService {

  private ip: string;
  constructor() { 
   // this.ip='181.115.96.3';
    this.ip='https://siget.jzsoluction.com';
   
    // this.ip='190.53.216.32';
    
  }

  getIPServer(){
    return this.ip;
  }
}
